import { inject, Injectable, signal } from '@angular/core';
import { AppApi } from '@api/AppApi';
import { take } from 'rxjs';
import { AppConfig } from '@api/model/my-api';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  public appConfig$$ = signal<AppConfig | undefined>(undefined);

  private api = inject(AppApi);

  public getConfig() {
    this.api.config
      .getAppConfig()
      .pipe(take(1))
      .subscribe((res) => {
        this.appConfig$$.set(res);
      });
  }
}
